module.exports = __webpack_public_path__ + "img/botonPanico.498cb74d.svg";